import { Action } from "@ngrx/store";
import {
  SectorMetaResponse,
  SectorToIndustryResponse,
} from "../models/industry-page.model";

export const SET_SECTOR_INDUSTRY = "SET_SECTOR_INDUSTRY";
export const CHANGE_SECTOR_INDUSTRY = "CHANGE_SECTOR_INDUSTRY";
export const SET_CLUSTER_DATA = "SET_CLUSTER_DATA";
export const SET_RELOAD_ALL = "SET_RELOAD_ALL";
export const SET_INDUSTRY_SUB_HEADER = "SET_INDUSTRY_SUB_HEADER";
export const SET_INDUSTRY_MEGAMENU_VISIBILITY =
  "SET_INDUSTRY_MEGAMENU_VISIBILITY";
export const CHANGE_SECTOR_INDUSTRY_AND_SET_CLUSTER_DATA =
  "CHANGE_SECTOR_INDUSTRY_AND_SET_CLUSTER_DATA";
export const RESET_SECTOR_INDUSTRY_DATA = "RESET_SECTOR_INDUSTRY_DATA";
export class SetSectorIndustry implements Action {
  readonly type = SET_SECTOR_INDUSTRY;
  constructor(
    public payload: {
      sectors: SectorMetaResponse;
      industries: Array<SectorToIndustryResponse>;
      industryId: string;
      selectedCluster?: number;
    },
  ) {}
}

export class SetIndustrySubHeader implements Action {
  readonly type = SET_INDUSTRY_SUB_HEADER;
  constructor(
    public payload: {
      data: {
        geographies: any;
        marketCaps: any;
        subGroups: any;
      };
      selectedCluster: any;
    },
  ) {}
}

export class ChangeSectorIndustry implements Action {
  readonly type = CHANGE_SECTOR_INDUSTRY;
  constructor(
    public payload: {
      selectedIndustryId: string;
      selectedCluster?: number;
      hasCompaniesData?: boolean;
    },
  ) {}
}

export class SetClusterData implements Action {
  readonly type = SET_CLUSTER_DATA;
  constructor(
    public payload: {
      error: boolean;
      allGeography: any;
      popularGeography: any;
      otherGeographies: any;
      popularSelected: any;
      otherSelected: any;
      marketCaps: any;
      selectedMarketCaps: any;
      clusters: any;
      selectedCluster: number;
      selectedCompanyCount: number;
      facetSelectionSettings: any;
    },
  ) {}
}

export class ChangeSectorIndustryAndSetClusterData implements Action {
  readonly type = CHANGE_SECTOR_INDUSTRY_AND_SET_CLUSTER_DATA;
  constructor(
    public payload: {
      selectedIndustryId: string;
      hasCompaniesData?: boolean;
      error: boolean;
      allGeography: any;
      popularGeography: any;
      otherGeographies: any;
      popularSelected: any;
      otherSelected: any;
      marketCaps: any;
      selectedMarketCaps: any;
      clusters: any;
      selectedCluster: number;
      selectedCompanyCount: number;
      facetSelectionSettings: any;
    },
  ) {}
}

export class SetReloadAll implements Action {
  readonly type = SET_RELOAD_ALL;
  constructor(
    public payload: {
      reloadAll: boolean;
      facetSelectionSettings: any;
    },
  ) {}
}

export class SetIndustryMengMenuVisibility implements Action {
  readonly type = SET_INDUSTRY_MEGAMENU_VISIBILITY;
  constructor(
    public payload: {
      isIndustryMegaMenuVisible: boolean;
    },
  ) {}
}

export class ResetSectorIndustryData implements Action {
  readonly type = RESET_SECTOR_INDUSTRY_DATA;
  constructor(
    public payload: {
      reset: boolean;
    },
  ) {}
}

export type Actions =
  | SetSectorIndustry
  | ChangeSectorIndustry
  | SetClusterData
  | SetIndustrySubHeader
  | SetReloadAll
  | SetIndustryMengMenuVisibility
  | ChangeSectorIndustryAndSetClusterData
  | ResetSectorIndustryData;
